import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";

import { OneTrustWebFormBranded } from "./OneTrustWebFormBranded";
import { OneTrustWebFormLegacy } from "./OneTrustWebFormLegacy";

interface OneTrustWebFormProps {
    id: string;
    buttonId: string;
    thankYouUrl: string;
}

export const OneTrustWebForm = (props: OneTrustWebFormProps): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    return jnjFullBranded ? <OneTrustWebFormBranded {...props} /> : <OneTrustWebFormLegacy {...props} />;
};

export default OneTrustWebForm;
